function getFormattedDate() {
  const date = new Date();
  return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

function pad2(n: number) {
  return String(n).padStart(2, "0");
}

/** Local wall time, seconds precision; safe for Windows filenames (no `:`). */
function formatLocalIsoDateTimeForFilename(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}T${pad2(date.getHours())}_${pad2(date.getMinutes())}_${pad2(date.getSeconds())}`;
}

function formatLocalIsoDateForFilename(date: Date): string {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

/** Extend by adding union members and a branch in {@link getFilenameTimeSuffix}. */
export type DownloadFilenameTimeFormat = "locale" | "iso-datetime" | "iso-date";

export function getFilenameTimeSuffix(format: DownloadFilenameTimeFormat): string {
  const now = new Date();
  switch (format) {
    case "locale":
      return getFormattedDate().split(",").join("");
    case "iso-datetime":
      return formatLocalIsoDateTimeForFilename(now);
    case "iso-date":
      return formatLocalIsoDateForFilename(now);
  }
}

/**
 * Triggers browser download of a Response as an xlsx file.
 * @param result - Fetch Response containing the file blob
 * @param fileName - Base filename without extension (will append .xlsx)
 * @param filenameTimeFormat - If set, appends a space + formatted local time to the filename
 */
export async function downloadXlsxFile(
  result: Response,
  fileName: string,
  filenameTimeFormat?: DownloadFilenameTimeFormat,
): Promise<void> {
  const blob = await result.blob();
  const downloadLink = document.createElement("a");
  const objectUrl = URL.createObjectURL(blob);
  downloadLink.href = objectUrl;
  const timePart =
    filenameTimeFormat === undefined ? "" : `_${getFilenameTimeSuffix(filenameTimeFormat)}`;
  downloadLink.download = fileName + timePart + ".xlsx";
  downloadLink.click();
  URL.revokeObjectURL(objectUrl);
}
